import { useState } from 'react'
import type { Dispatch, SetStateAction } from 'react'

const getCookieValue = (key: string): string | void => {
  if (typeof window !== 'undefined') {
    const cookieValue = document.cookie.split(';').reduce((total, currentCookie) => {
      const currentValue = currentCookie.split('=')

      return currentValue[0].trim() === key ? currentValue[1] : total
    }, '')

    return cookieValue
  }
}

export type useCookie = <T>(key: string, defaultValue: T) => [T, Dispatch<SetStateAction<T>>, T]

const useCookie = <T>(key: string, defaultValue: T) => {
  const [cookie, setCookie] = useState(() => {
    const currentValue = getCookieValue(key)

    if (currentValue) return currentValue

    return defaultValue
  })

  const updateCookie = (newValue: string) => {
    setCookie(newValue)
    if (typeof document !== 'undefined') {
      document.cookie = `${key}=${newValue}; expires=Tue, 19 Jan 2038 04:14:07 GMT; path=/`
    }
  }

  return [cookie, updateCookie] as const
}

export default useCookie
